var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLogging)?_c('nav-menu'):_vm._e(),_c('router-view'),_c('el-footer',{staticStyle:{"padding-top":"20px","text-align":"center","color":"white","font-size":"16px","background-color":"#008f39"}},[_vm._v("Copyright © 2026 EcoWastes")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }